export default "__VITE_ASSET__6ba0b79e__"